var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5479 24.6693L16.3439 16.0026L22.5465 7.33594H20.9212L14.7159 16.0026L20.9212 24.6693H22.5479ZM14.8199 24.6693L8.61452 16.0026L14.8212 7.33594H13.1945L6.98919 16.0026L13.1945 24.6693H14.8199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavleft);
export default __webpack_public_path__ + "static/media/navleft.bdee8736b0fb82f0d984c4d9c07181a8.svg";
export { ForwardRef as ReactComponent };